import React from 'react'
import styled from 'styled-components'
import { Box, Text as ChakraText } from '@chakra-ui/react'

const Wrapper = styled(Box)`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 320px;
`

const Title = styled(Box)`
  margin-top: -8vh;
  font-weight: bold;
  color: black;
  font-size: 3.375rem;

  span {
    font-size: 3.125rem;
  }
`

const NotFoundLayout = (): React.ReactElement => (
  <Wrapper>
    <Title>404</Title>
    <ChakraText>Page not found.</ChakraText>
  </Wrapper>
)

export default NotFoundLayout
